















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { EditableFormatSummary, FormatStructureEditor, FormatValidator } from "../../../domain/editableFormat";
import { FormatDebuggableMixin } from "./mixins";

interface IResult {
  isOk: boolean;
  message: string;
  format: EditableFormatSummary;
}

@Component
export default class FormatsTestTool extends Mixins(FormatDebuggableMixin) {
  @Prop()
  formats: EditableFormatSummary[];

  data() {
    return {
      isRunning: false,
      isCanceling: false,
      results: [] as IResult[],
    };
  }
  isRunning: boolean;
  isCanceling: boolean;
  results: IResult[];

  get isRunnable(): boolean {
    return !this.isRunning
        && !this.isCanceling;
  }

  get isCancelable(): boolean {
    return this.isRunning
        && !this.isCanceling;
  }

  get log(): string {
    return Enumerable.from(this.results)
      .select(r => r.message + " " + r.format.id + ") " + r.format.name)
      .reverse()
      .toArray()
      .join("\r\n");
  }

  get errorCount(): number {
    return Enumerable.from(this.results).count(r => !r.isOk);
  }

  get hasError(): boolean {
    return (0 < this.errorCount);
  }

  async runTranslation(): Promise<void> {
    this.run(this.processTranslation);
  }

  private async processTranslation(format: EditableFormatSummary): Promise<IResult> {
    const results = await Promise.all([
      await this.registry.formatEditorDeveloper.getFormatService().loadFormatStructureSource(format.id),
      await this.registry.formatEditorDeveloper.getFormatService().translateFormatStructuteToSource(
        await this.registry.editableFormat.getFormatRepository().getFormatStructure(format.id), false),
    ]);
    const isOk = this.areEqual(this.complementor.toComplementedSource(results[0]), this.complementor.toComplementedSource(results[1]));
    return {
      isOk,
      message: isOk ? "◎差分なし" : "★差分あり",
      format,
    };
  }

  async runValidation(): Promise<void> {
    this.run(this.processValidation);
  }

  private async processValidation(format: EditableFormatSummary): Promise<IResult> {
    const validator = new FormatValidator();
    const structure = await this.registry.editableFormat.getFormatRepository().getFormatStructure(format.id);
    const alerts = validator.validate(new FormatStructureEditor(structure, await this.registry.editableFormat.getSpecificationRepository().getSpecification(structure.version)));
    const errorCount = Enumerable.from(alerts).count(a => a.isError);
    const isOk = (errorCount === 0);
    return {
      isOk,
      message: (isOk ? "◎検証OK" : "★検証NG") + " " + errorCount + "/" + (alerts.length - errorCount),
      format,
    };
  }

  async run(process: (f: EditableFormatSummary) => Promise<IResult>): Promise<void> {
    this.isRunning = true;
    this.results = [];
    for (const format of this.formats) {
      if (this.isCanceling) {
        break;
      }
      this.results.push(await process(format));
    }
    this.isRunning = false;
    this.isCanceling = false;
  }

  cancel(): void {
    if (this.isRunning) {
      this.isCanceling = true;
    }
  }
}
